import actions from './actions';

const {
  GET_ADDON_CHOICES_BEGIN,
  GET_ADDON_CHOICES_ERR,
  GET_ADDON_CHOICES_SUCCESS,

  GET_SINGLE_CHOICE_BEGIN,
  GET_SINGLE_CHOICE_ERR,
  GET_SINGLE_CHOICE_SUCCESS,

  ADD_ADDON_CHOICE_BEGIN,
  ADD_ADDON_CHOICE_SUCCESS,
  ADD_ADDON_CHOICE_ERR,

  EDIT_ADDON_CHOICE_BEGIN,
  EDIT_ADDON_CHOICE_SUCCESS,
  EDIT_ADDON_CHOICE_ERR,

  DELETE_ADDON_CHOICE_BEGIN,
  DELETE_ADDON_CHOICE_ERR,
  DELETE_ADDON_CHOICE_SUCCESS,
} = actions;

const initialStateSingleAddonChoice = {
  data: null,
  loading: false,
  error: null,
  isSubmitting: false,
};

const initialStateAddonChoices = {
  data: [],
  loading: false,
  error: null,
  delete: {
    /**
     * id of addons that are loading
     *  {
     *    [id]: loading ? true : false
     *  }
     */
    loading: {},
  },
};

const addonChoicesReducer = (state = initialStateAddonChoices, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_ADDON_CHOICES_BEGIN:
      return {
        ...state,
        loading: true,
        data: [],
        err: null,
      };
    case GET_ADDON_CHOICES_SUCCESS:
      return {
        ...state,
        data,
        loading: false,
      };
    case GET_ADDON_CHOICES_ERR:
      return {
        ...state,
        err,
        loading: false,
      };
    case DELETE_ADDON_CHOICE_BEGIN:
      return {
        ...state,
        delete: {
          loading: {
            ...state.delete.loading,
            [action.id]: true,
          },
        },
      };
    case DELETE_ADDON_CHOICE_ERR:
      return {
        ...state,
        delete: {
          loading: {
            ...state.delete.loading,
            [action.id]: false,
          },
        },
      };
    case DELETE_ADDON_CHOICE_SUCCESS:
      return {
        ...state,
        delete: {
          loading: {
            ...state.delete.loading,
            [action.id]: false,
          },
        },
      };
    default:
      return state;
  }
};

const singleAddonChoiceReducer = (state = initialStateSingleAddonChoice, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_SINGLE_CHOICE_BEGIN:
      return {
        ...state,
        loading: true,
        data: null,
        err: null,
      };
    case GET_SINGLE_CHOICE_SUCCESS:
      return {
        ...state,
        loading: false,
        data,
      };
    case GET_SINGLE_CHOICE_ERR:
      return {
        ...state,
        loading: false,
        err,
      };
    case ADD_ADDON_CHOICE_BEGIN:
      return {
        ...state,
        isSubmitting: true,
      };
    case ADD_ADDON_CHOICE_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
      };
    case ADD_ADDON_CHOICE_ERR:
      return {
        ...state,
        isSubmitting: false,
      };
    case EDIT_ADDON_CHOICE_BEGIN:
      return {
        ...state,
        isSubmitting: true,
      };
    case EDIT_ADDON_CHOICE_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
      };
    case EDIT_ADDON_CHOICE_ERR:
      return {
        ...state,
        isSubmitting: false,
      };
    default:
      return state;
  }
};

export { addonChoicesReducer, singleAddonChoiceReducer };
